module.exports = __webpack_public_path__ + "img/ship_images01.eb6e5ffa.jpg";